import { render } from "./addotherincome.vue?vue&type=template&id=750e200e&scoped=true"
import script from "./addotherincome.vue?vue&type=script&lang=js"
export * from "./addotherincome.vue?vue&type=script&lang=js"

import "./addotherincome.vue?vue&type=style&index=0&id=750e200e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-750e200e"]])

export default __exports__